'use client';

import React from 'react';
import { Icon } from '@/components/Icons/Icon';

export interface PersonaNameTagProps {
  name: string;
  isSmUp: boolean;
}

/** Small "AI · {persona}" tag pinned to the top-left of the avatar stage. */
export const PersonaNameTag: React.FC<PersonaNameTagProps> = ({ name, isSmUp }) => (
  <div className="absolute top-1 left-1 sm:left-4 sm:top-4 rounded-full bg-white/50 sm:bg-white/10 px-2 sm:py-1 max-sm:pr-2 max-sm:pl-1 backdrop-blur-sm flex items-center gap-1 max-sm:border max-sm:border-white/30 max-sm:min-h-8">
    <div className="flex items-center gap-1 rounded-full bg-semantic-globals-page-background px-2 py-1">
      <span className="text-[0.65rem] sm:text-xs font-bold text-semantic-text-primary">AI</span>
      <Icon name="Sparkle" size={isSmUp ? 12 : 8} weight="fill" />
    </div>
    <span className="whitespace-nowrap text-[0.65rem] sm:text-xs font-bold text-semantic-text-primary">
      {name}
    </span>
  </div>
);
